exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-verbs-practice-tsx": () => import("./../../../src/pages/verbs/practice.tsx" /* webpackChunkName: "component---src-pages-verbs-practice-tsx" */),
  "component---src-pages-verbs-quiz-tsx": () => import("./../../../src/pages/verbs/quiz.tsx" /* webpackChunkName: "component---src-pages-verbs-quiz-tsx" */),
  "component---src-pages-verbs-search-tsx": () => import("./../../../src/pages/verbs/search.tsx" /* webpackChunkName: "component---src-pages-verbs-search-tsx" */)
}

